import React from 'react';
import { X } from 'lucide-react';
import { AIIslandInput } from './AIIslandInput';

export function AIIslandDock({
  onExpand,
  attachedSelection,
  onClearSelection,
  promptValue,
  onPromptChange,
  onSubmit,
  placeholder,
  selectionLabel,
  shortcutLabel,
  inputRef,
  clearSelectionLabel,
}) {
  return (
    <div className="ai-island-dock">
      {attachedSelection && (
        <div className="ai-island-dock__selection-chip">
          <span>{selectionLabel}</span>
          <button
            type="button"
            onClick={onClearSelection}
            aria-label={clearSelectionLabel || 'Remove selection'}
          >
            <X size={12} />
          </button>
        </div>
      )}
      <AIIslandInput
        variant="dock"
        value={promptValue}
        onChange={onPromptChange}
        onSubmit={onSubmit}
        onFocus={onExpand}
        placeholder={placeholder}
        shortcutLabel={shortcutLabel}
        inputRef={inputRef}
      />
    </div>
  );
}
